import type {
    CreateTrustedContactDto,
    TrustedContact,
} from '@fruitful/investment-management';
import { useQueryClient } from '@tanstack/react-query';

import { requestBuilder } from '../../http/RequestBuilder';

interface UpsertTrustedContactParams {
    userId: string;
}

const useUpsertTrustedContact = (
    options?: Parameters<
        ReturnType<
            typeof requestBuilder.mutation<
                TrustedContact,
                CreateTrustedContactDto,
                UpsertTrustedContactParams
            >
        >
    >[0],
) => {
    const queryClient = useQueryClient();

    return requestBuilder.mutation<
        TrustedContact,
        CreateTrustedContactDto,
        UpsertTrustedContactParams
    >({
        endpoint: ({ userId }) => `/api/user/${userId}/trusted-contacts`,
        method: 'POST',
    })({
        ...options,
        onSuccess: async (data, variables, context, mutation) => {
            await queryClient.invalidateQueries({
                queryKey: [`getTrustedContact-${variables.urlParams?.userId}`],
            });
            await options?.onSuccess?.(data, variables, context, mutation);
        },
    });
};

export default useUpsertTrustedContact;
